import script from "./walletOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./walletOverview.vue?vue&type=script&setup=true&lang=js"

import "./walletOverview.vue?vue&type=style&index=0&id=0bbd6e4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bbd6e4c"]])

export default __exports__